export default "__VITE_ASSET__0c8a8aa7__"